export const cacheKeys = {
	cumulativeContentsDist: "cumulativeContentsDist",
	studypack: "studypack",
	practiceTest: "practiceTest",
	progress: "progress",
	examsCount: "examsCount",
	leaderboard: "leaderboard",
	userLeaderboard: "userLeaderboard",
	home: "home",
	itemsCount: "itemsCount",
	sessionConfig: "sessionConfig",
	sessionItems: "sessionItems",
	avatars: "avatars",
	activeAccessCodes: "activeAccessCodes",
	authVerifyExamContext: "authVerifyExamContext",
	examDetails: "examDetails",
	exams: "exams",
	externalAuthPracticeTest: "externalAuthPracticeTest",
	versionChecker: "versionChecker",
	categories: "categories",
	dashboard: "dashboard",
	insights: "insights",
	productDetails: "productDetails",
	productMetadata: "productMetadata",
	cache: "cache",
	migration: "migration",
	podcasts: "podcasts",
	answerEvent: "answerEvent",
	createSession: "createSession",
	resumeSession: "resumeSession",
	endSession: "endSession",
	user: "user",
	userSessions: "userSessions",
	tip: "tip",
};
